import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import styles from './styles'
import GeneralSettings from 'src/components/user-access'
const LearnerAccess = props => {
  const { classes } = props
  return (
    <div className={classes.root}>
      <div className={classes.root__header}>
        <Typography
          fontSize="18px"
          fontWeight={500}
          style={{
            padding: '8px 0px',
          }}
        >
          Learners’ authentication
        </Typography>
        <Typography fontSize="14px" fontWeight={400} color="#838D98">
          Select who can access and how.
        </Typography>
      </div>
      <GeneralSettings />
    </div>
  )
}

export default withStyles(styles)(LearnerAccess)
